import { render, staticRenderFns } from "./LoadTender.vue?vue&type=template&id=357ba460&scoped=true&"
import script from "./LoadTender.vue?vue&type=script&lang=js&"
export * from "./LoadTender.vue?vue&type=script&lang=js&"
import style0 from "./LoadTender.vue?vue&type=style&index=0&id=357ba460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ba460",
  null
  
)

export default component.exports